export const PartsSupplierPartsColumnsModel = [
  {
    label: 'Supplier Name',
    type: 'string',
    property: 'name',
    isVisible: true
  },
  {
    label: 'SKU',
    type: 'string',
    property: 'sku',
    isVisible: true
  },
  {
    label: 'Cost',
    type: 'number',
    property: 'cost',
    isVisible: true
  }
];
